'use strict'

import { Enum } from './enums'

/**
 * 组织节点类型。
 */

const OrganizationTypeEnum = new Enum({
  PLOT_MANAGEMENT: { value: 1, summaryCN: 'plot_mgmt', summaryEN: '基地' }
})

export { OrganizationTypeEnum }



// WEBPACK FOOTER //
// ./src/utils/OrganizationTypeEnum.js